import type { SelectOption } from '@/components/forms/SelectField';
import { useEnumOptions } from '@/features/common/enums/useEnumOptions';

// Tenant setup enum options, fetched from the backend (ABP EnumHelper.GetDisplayName).
// The display names mirror each C# enum's [Display(Name=...)] attributes.
const ENUM_NAMES = [
  'TypeOfEntity',
  'PrudentialClassification',
  'PermanentCapitalRequirement',
  'ProductType',
  'BasisOfProvisionOfServices',
  'AccountingFramework',
  'LevelOfApplication',
  'ReasonForFalling',
];

export function useTenantEnumOptions() {
  const { options } = useEnumOptions(ENUM_NAMES);
  const pick = (name: string): SelectOption[] => options[name] ?? [];

  return {
    typeOfEntityOptions: pick('TypeOfEntity'),
    prudentialClassificationOptions: pick('PrudentialClassification'),
    permanentCapitalRequirementOptions: pick('PermanentCapitalRequirement'),
    productTypeOptions: pick('ProductType'),
    basisOfProvisionOptions: pick('BasisOfProvisionOfServices'),
    accountingFrameworkOptions: pick('AccountingFramework'),
    levelOfApplicationOptions: pick('LevelOfApplication'),
    reasonForFallingOptions: pick('ReasonForFalling'),
  };
}
